import React, { useContext, useEffect } from "react";
import { ResultContext, VestingFrequency } from "../ResultContext";
import { Label } from "../components/Label";

export function VestingFrequencyInput({ questionId }: { questionId: number }) {
  const { result, setResult } = useContext(ResultContext);

  const foundResult = (result[questionId] as {
    frequency: VestingFrequency;
    type: string;
  }) || { frequency: VestingFrequency.Monthly, type: "Linear" };

  useEffect(() => {
    if (!result[questionId]) {
      const copy = { ...result };

      copy[questionId] = {
        frequency: VestingFrequency.Monthly,
        type: "Linear",
      };

      setResult(copy);
    }
    // eslint-disable-next-line
  }, [questionId]);

  return (
    <div className="flex flex-column ">
      <div className="flex flex-column">
        <label>Frequency</label>
        <select
          value={foundResult.frequency}
          onChange={(e) => {
            const copy = { ...result };

            copy[questionId] = {
              ...foundResult,
              frequency: e.target.value as VestingFrequency,
            };

            setResult(copy);
          }}
        >
          {Object.values(VestingFrequency).map((item, index) => {
            return (
              <option value={item} key={index}>
                {item}
              </option>
            );
          })}
        </select>
        <div className="mt-4">
          <Label
            title="Vesting Scheme"
            information={
              <div className="text-justify">
                Linear vesting means that the shares will vest in equal amounts
                every year. Backloaded vesting means that the vesting schedule
                is structured so that a larger percentage vests in the later
                years of the vesting period.
              </div>
            }
          />
          <select
            value={foundResult.type}
            onChange={(e) => {
              const copy = { ...result };

              copy[questionId] = {
                ...foundResult,
                type: e.target.value,
              };

              setResult(copy);
            }}
          >
            <option value="Linear">Linear</option>
            <option value="Back Loaded">Back Loaded</option>
          </select>
        </div>
      </div>
    </div>
  );
}
